import VerifiedIcon from "@mui/icons-material/Verified";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import companyPlaceholder from "../../assets/images/placeholder_img.jpg";
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  FETCH_COMPANIES_2,
  FETCH_COMPANIES_ADDRESSES,
  FETCH_COMPANIES_TRADES,
  FETCH_COMPANY_ADDRESS_FOR_WEB,
  FETCH_COMPANY_TRADES_FOR_WEB,
  GET_FOLLOW_COMPANIES,
  GET_COMPANIES_DETAILS_FOR_WEB,
  FETCH_JOB_SEARCH_RESULTS_NEW,
  SAVE_FOLLOW_ENTITIES
} from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { useSelector } from "react-redux";
import {
  Box,
  Card,
  CardHeader,
  CardMedia,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Stack,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import PlaceholderImg from "../../assets/images/placeholder_img.jpg";
import PictureViewer from "../common/PictureViewer";
import { BIRed, BIBlue } from "../../assets/helpers";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CompanyAboutSection from "./CompanyAboutSection";
import Loader from "../../common/Loader";
import CompanyProjectSection from "./CompanyProjectSection";
import CompanyProductSection from "./CompanyProductSection";
import CompanySiteSection from "./CompanySiteSection";
import SendInChatModal from "../common/SendInChatModal";
import NoSuchPage from "../common/NoSuchPage";
import { Getrequestcall } from "../../request/Getrequest";
import { SignInCard } from "../common/SignInCard";
import { useDispatch } from "react-redux";
import { setShowReport } from "../../redux/actions/actions";
import Pageheader from "../common/Pageheader";
import { English } from "../../constant/EnglishFallback";
import Pages from "../../constant/ReportModel";
import moment from "moment";
import { getJobIdFromItem } from "../job-posting/favoriteUtils";

const CompanyProfile = () => {
  let scrollTargetId = "scrollablediv_prodcut";
  let { id } = useParams();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { loginData, multiLanguageData, jobSelectedLocation } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const navigate = useNavigate();
  const LanguageData = multiLanguageData?.Companies || {};
  const {
    TEXT_COMPANY_PROFILES = English.Companies.TEXT_COMPANY_PROFILES,
    TEXT_COMPANY = English.Companies.TEXT_COMPANY,
    TEXT_PRODUCTS = English.Companies.TEXT_PRODUCTS,
    TEXT_PROJECTS = English.Companies.TEXT_PROJECTS,
    TEXT_SITES = English.Companies.TEXT_SITES,
    TEXT_JOB_POSTINGS = English.Companies.TEXT_JOB_POSTINGS,
    TEXT_NO_RESULTS_FOUND = English.Companies.TEXT_NO_RESULTS_FOUND,
    BUTTON_SEND_IN_CHAT = English.Companies.BUTTON_SEND_IN_CHAT,
    BUTTON_SHARE = English.Companies.BUTTON_SHARE,
    BUTTON_REPORT = English.Companies.BUTTON_REPORT
  } = LanguageData || {};

  const isAndroid = /Android/i.test(navigator.userAgent);
  const isIphone = /iPhone/i.test(navigator.userAgent);
  const isIpad = /iPad/i.test(navigator.userAgent);

  const [companyData, setCompanyData] = useState({
    companyDetails: null,
    tradeList: [],
    companyAddress: [],
    followDetails: null
  });

  const [activeTab, setActiveTab] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [showImagePreview, setShowImagePreview] = useState(false);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [showSendInChatModal, setShowSendInChatModal] = useState(false);
  const [noSuchData, setNoSuchData] = useState(false);
  const [companyJobPostings, setCompanyJobPostings] = useState([]);
  const [companyJobPostingsLoading, setCompanyJobPostingsLoading] = useState(false);
  const [jobPostingsPage, setJobPostingsPage] = useState(1);
  const [hasMoreJobPostings, setHasMoreJobPostings] = useState(true);
  const [followLoading, setFollowLoading] = useState(false);
  const jobPostingsLoadMoreRef = useRef(null);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const companyTabs = [TEXT_PROJECTS, TEXT_SITES, TEXT_PRODUCTS, TEXT_JOB_POSTINGS];
  const restrictedTabs = [TEXT_PROJECTS, TEXT_SITES, TEXT_PRODUCTS, TEXT_JOB_POSTINGS];

  useEffect(() => {
    if (pathname.includes("proxySite")) {
      getProxyPageData();
    } else if (id) {
      getData();
    }
    setActiveTab(TEXT_PROJECTS);
  }, [id, currentUserId, pathname]);

  const mergeTradeListWithDetails = (trades = [], details = null) => {
    let list = Array.isArray(trades) ? [...trades] : [];
    if (details?.tradeId && details?.tradeName) {
      const exists = list.some(
        (t) => Number(t?.tradeId) === Number(details.tradeId)
      );
      if (!exists) {
        list.unshift({
          tradeId: details.tradeId,
          tradeName: details.tradeName,
          tradeType: "Main"
        });
      }
    }
    return list;
  };

  const mergeAddressListWithDetails = (addresses = [], details = null) => {
    if (Array.isArray(addresses) && addresses.length > 0) {
      return addresses;
    }
    if (
      details?.address ||
      details?.city ||
      details?.contact ||
      details?.email ||
      details?.phone
    ) {
      return [
        {
          address: details.address || "",
          city: details.city || "",
          province: details.province || "",
          postalCode: details.postalCode || "",
          country: details.country || "",
          contactPerson: details.contact || "",
          phone: details.phone || "",
          email: details.email || ""
        }
      ];
    }
    return [];
  };

  // Proxy sites
  const getProxyPageData = async () => {
    setShowLoader(true);
    try {
      const [companyDetails, companyAddress, tradeList] = await Promise.all([
        fetchCompaniesDetailsForWeb().catch((e) => null), // handle errors individually
        getCompanyAddressListForWeb().catch((e) => []),
        getCompanyTradeListForWeb().catch((e) => [])
      ]);
      setCompanyData({
        companyDetails,
        companyAddress: mergeAddressListWithDetails(companyAddress, companyDetails),
        tradeList: mergeTradeListWithDetails(tradeList, companyDetails)
      });
      openInPhone();
    } catch (error) {
      console.log("getProxyPageData-> Error When Getting Data For Proxy Page: ", error);
    } finally {
      setShowLoader(false);
    }
  };

  function openInPhone() {
    if (isAndroid) {
      const androidUrl = `intent://?screenName=${"CompanyInfo"}&id=${id}#Intent;scheme=mybuilderid;package=com.mybuilderid;end`;
      window.location.replace(androidUrl);
    } else if (isIphone || isIpad) {
      const iPhoneUrl = `mybuilderid://?screenName=${"CompanyInfo"}&id=${id}`;
      window.location.replace(iPhoneUrl);
    }
  }

  const fetchCompaniesDetailsForWeb = async () => {
    try {
      const res = await Getrequestcall(`${GET_COMPANIES_DETAILS_FOR_WEB}/${id}`, undefined);
      let resData = res?.data?.data[0] ?? null;
      setNoSuchData(resData ? false : true);
      return resData;
    } catch (error) {
      console.log("fetchCompaniesDetailsForWeb-> Error When Fetching Companies Detail: ", error);
    }
  };

  const getCompanyAddressListForWeb = async () => {
    try {
      const obj = {
        SearchList: [{ companyId: id }]
      };
      const res = await Postrequestcall(FETCH_COMPANY_ADDRESS_FOR_WEB, obj, undefined);
      let resData = res?.data?.data ?? [];
      return resData;
    } catch (error) {
      console.log(
        "getCompanyAddressListForWeb-> Error When Fetching Company Address List: ",
        error
      );
    }
  };

  const getCompanyTradeListForWeb = async () => {
    try {
      let obj = {
        SearchList: [{ CompanyId: id }]
      };
      const res = await Postrequestcall(FETCH_COMPANY_TRADES_FOR_WEB, obj, undefined);
      let resData = res?.data?.data ?? [];
      return resData;
    } catch (error) {
      console.log("getCompanyTradeListForWeb-> Error When Fetching Company Trade List: ", error);
    }
  };

  // Proxy site end
  const getData = async () => {
    setShowLoader(true);
    try {
      const [companyDetails, companyAddress, tradeList, followDetails] = await Promise.all([
        fetchCompaniesDetails().catch((e) => null), // handle errors individually
        getCompanyAddressList().catch((e) => []),
        getCompanyTradeList().catch((e) => []),
        fetchCompanyFollowDetails().catch((e) => null)
      ]);

      setCompanyData({
        companyDetails,
        companyAddress: mergeAddressListWithDetails(companyAddress, companyDetails),
        tradeList: mergeTradeListWithDetails(tradeList, companyDetails),
        followDetails
      });
    } catch (error) {
      console.log("getData-> Error When Fetching All Data For Proxy: ", error);
    } finally {
      setShowLoader(false);
    }
  };

  const fetchCompaniesDetails = async () => {
    try {
      // OLD API: FETCH_COMPANIES (commented, do not delete)
      // const obj = {
      //   SearchList: [{ Manufacturer: false, id }]
      // };
      // const res = await Postrequestcall(FETCH_COMPANIES, obj, loginData?.accessToken);
      
      // NEW API: FETCH_COMPANIES_2 (active)
      const obj = {
        UserId: currentUserId,
        SearchString: "",
        PageNumber: 1,
        PageSize: 1,
        Manufacturer: false,
        Id: Number(id) || 0
      };
      const res = await Postrequestcall(FETCH_COMPANIES_2, obj, loginData?.accessToken);
      let resData = res?.data?.data?.[0] ?? null;
      setNoSuchData(resData ? false : true);
      return resData;
    } catch (error) {
      console.log("fetchCompaniesDetails-> Error When Fetching Companie: ", error);
    }
  };

  const fetchCompanyFollowDetails = async () => {
    try {
      const obj = {
        UserId: currentUserId,
        CompanyId: Number(id) || 0
      };
      const res = await Postrequestcall(GET_FOLLOW_COMPANIES, obj, loginData?.accessToken);
      return res?.data?.data?.[0] ?? null;
    } catch (error) {
      console.log("fetchCompanyFollowDetails-> Error When Fetching Follow Details: ", error);
    }
  };

  const getCompanyAddressList = async () => {
    try {
      const obj = {
        SearchList: [{ companyId: id }]
      };
      const res = await Postrequestcall(FETCH_COMPANIES_ADDRESSES, obj, loginData?.accessToken);
      let resData = res?.data?.data ?? [];
      return resData;
    } catch (error) {
      console.log("getCompanyAddressList-> Error When Fetching Companies Address: ", error);
    }
  };

  const getCompanyTradeList = async () => {
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 0,
        FullSearch: "",
        UserId: Number(currentUserId),
        IncludeRecordNr: true,
        TypeOfObjectReturned: "",
        SearchList: [{ CompanyId: id }]
      };
      const res = await Postrequestcall(FETCH_COMPANIES_TRADES, obj, loginData?.accessToken);
      let resData = res?.data?.data ?? [];
      return resData;
    } catch (error) {
      console.log("getCompanyTradeList-> Error When Fetching Companies Trade: ", error);
    }
  };

  const onFollowCompany = async () => {
    if (!currentUserId || followLoading) return;

    try {
      setFollowLoading(true);
      const nextFollowState = !companyData?.followDetails?.isFollowing;
      const obj = {
        UserId: currentUserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: companyData?.followDetails?.followingId || 0,
            EntityTypeId: 8,
            EntityId: Number(id) || 0,
            UserId: currentUserId,
            IsFollowing: nextFollowState,
            ModifiedBy: currentUserId
          }
        ]
      };
      const res = await Postrequestcall(SAVE_FOLLOW_ENTITIES, obj, loginData?.accessToken);
      const followingId = res?.data?.data?.[0]?.objData?.id || companyData?.followDetails?.followingId || 0;
      setCompanyData((prev) => ({
        ...prev,
        followDetails: {
          ...prev?.followDetails,
          isFollowing: nextFollowState,
          followingId
        }
      }));
    } catch (error) {
      console.log("onFollowCompany-> Error When Saving Follow Status: ", error);
    } finally {
      setFollowLoading(false);
    }
  };

  let isSharing = false;
  const onShareClick = async () => {
    if (navigator.share) {
      if (isSharing) return;

      const shareData = {
        title: "Company Profile",
        url: window.location.href
      };

      isSharing = true;
      navigator
        .share(shareData)
        .catch((error) => console.error("onShareClick-> Error When Trying To Share: ", error))
        .finally(() => {
          isSharing = false;
        });
    } else {
      try {
        try {
          await navigator.clipboard.writeText(window.location.href);
        } catch (err) {
          const textArea = document.createElement("textarea");
          textArea.value = window.location.href;
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          document.body.removeChild(textArea);
        }
        alert("Link copied to clipboard");
        isSharing = false;
      } catch (error) {
        console.log("onShareClick-> Error When Trying To Share (fallback): ", error);
      }
    }
  };

  const onSendChatClick = () => {
    setShowSendInChatModal(true);
  };

  const onReportClick = () => {
    let reportObj = {
      showReport: true,
      recordId: companyData?.companyDetails?.id,
      name: Pages?.companiesProfile?.name,
      AppScreenId: Pages?.companiesProfile?.id,
      isVerified: !!companyData?.companyDetails?.verified
    };
    dispatch(setShowReport(reportObj));
  };

  const onTradesSaveSuccessfully = async () => {
    // setShowLoader(true);
    try {
      const resData = await getCompanyTradeList();
      setCompanyData((prevData) => ({
        ...prevData,
        tradeList: mergeTradeListWithDetails(resData ?? [], prevData?.companyDetails)
      }));
    } catch (error) {
      console.error(
        "onTradesSaveSuccessfully-> Error When Trying To Get Company Trade List: ",
        error
      );
    } finally {
      // setShowLoader(false);
    }
  };

  const onCompanyDetailsSaveSuccessfully = async () => {
    //setShowLoader(true);
    try {
      const resData = await fetchCompaniesDetails();
      setCompanyData((prevData) => ({
        ...prevData,
        companyDetails: resData ?? null,
        tradeList: mergeTradeListWithDetails(prevData?.tradeList, resData),
        companyAddress: mergeAddressListWithDetails(prevData?.companyAddress, resData)
      }));
    } catch (error) {
      console.error(
        "onCompanyDetailsSaveSuccessfully-> Error When Fetching Companies Detail: ",
        error
      );
    } finally {
      //setShowLoader(false);
    }
  };

  const onCompanyAddressSaveSuccessfully = async () => {
    // setShowLoader(true);
    try {
      const resData = await getCompanyAddressList();
      setCompanyData((prevData) => ({
        ...prevData,
        companyAddress: mergeAddressListWithDetails(resData ?? [], prevData?.companyDetails)
      }));
    } catch (error) {
      console.error(
        "onCompanyAddressSaveSuccessfully-> Error When Getting Company Address List: ",
        error
      );
    } finally {
      // setShowLoader(false);
    }
  };

  useEffect(() => {
    setCompanyJobPostings([]);
    setJobPostingsPage(1);
    setHasMoreJobPostings(true);
  }, [id]);

  const fetchCompanyJobPostings = useCallback(
    async (pageNumber = 1, append = false) => {
      if (!id) return;
      setCompanyJobPostingsLoading(true);
      try {
        const address = companyData?.companyAddress?.[0] ?? {};
        const latitude = null;
        const longitude = null;
        const payload = {
          UserId: currentUserId,
          PageNumber: pageNumber,
          PageSize: 20,
          Latitude: latitude,
          Longitude: longitude,
          SearchString: "",
          Types: "",
          Trades: "",
          Location: "",
          RadiusKm: 0,
          Category: "",
          IncludeUserRecords: true,
          CompanyId: Number(companyData?.companyDetails?.id || id) || 0
        };
        const response = await Postrequestcall(
          FETCH_JOB_SEARCH_RESULTS_NEW,
          payload,
          loginData?.accessToken
        );
        const jobResults = response?.data?.data || [];
        setCompanyJobPostings((prev) => (append ? [...prev, ...jobResults] : jobResults));
        setHasMoreJobPostings(jobResults.length === 20);
        setJobPostingsPage(pageNumber);
      } catch (error) {
        console.log("fetchCompanyJobPostings-> Error When Fetching Job Postings: ", error);
      } finally {
        setCompanyJobPostingsLoading(false);
      }
    },
    [
      id,
      currentUserId,
      loginData?.accessToken,
      companyData?.companyAddress,
      companyData?.companyDetails,
      jobSelectedLocation?.lat,
      jobSelectedLocation?.lng
    ]
  );

  useEffect(() => {
    if (activeTab === TEXT_JOB_POSTINGS && !companyJobPostings.length) {
      fetchCompanyJobPostings(1, false);
    }
  }, [activeTab, fetchCompanyJobPostings, companyJobPostings.length]);

  useEffect(() => {
    if (activeTab !== TEXT_JOB_POSTINGS || !hasMoreJobPostings) {
      return;
    }
    if (companyJobPostingsLoading) {
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          fetchCompanyJobPostings(jobPostingsPage + 1, true);
        }
      },
      {
        root: null,
        rootMargin: "200px",
        threshold: 0
      }
    );
    const current = jobPostingsLoadMoreRef.current;
    if (current) {
      observer.observe(current);
    }
    return () => {
      if (current) {
        observer.unobserve(current);
      }
      observer.disconnect();
    };
  }, [
    activeTab,
    companyJobPostingsLoading,
    fetchCompanyJobPostings,
    hasMoreJobPostings,
    jobPostingsPage
  ]);

  const handleJobClick = (job) => {
    const jobId = getJobIdFromItem(job);
    if (!jobId) {
      return;
    }
    navigate("/job-postings", {
      state: {
        jobId,
        isExternal: job?.isExternal
      }
    });
  };

  const renderCompanyJobPostings = () => {
    if (companyJobPostingsLoading && jobPostingsPage === 1) {
      return (
        <Stack sx={{ height: "220px", alignItems: "center", justifyContent: "center" }}>
          <Loader />
        </Stack>
      );
    }
    if (!companyJobPostings.length) {
      return (
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {TEXT_NO_RESULTS_FOUND}
        </Typography>
      );
    }
    return (
      <Stack spacing={2}>
        {companyJobPostings.map((job, index) => {
          const jobTitle =
            job?.title ||
            job?.jobTitle ||
            job?.jobName ||
            job?.name ||
            job?.jobHeadline ||
            "Job Posting";
          const jobLocation = job?.location || job?.city || job?.address || job?.site?.name || "";
          const jobTypeLabel = job?.jobEmploymentType || job?.jobType || job?.typeName || "";
          const tradeItems = Array.isArray(job?.trades)
            ? job.trades
            : Array.isArray(job?.jobPostTypes)
            ? job.jobPostTypes
            : [];
          const tradeLabels =
            tradeItems?.map((trade) => trade?.tradeName || trade?.typeName).filter(Boolean) ?? [];
          const postedAt = job?.jobPostedDate || job?.dateCreated || job?.createdDate;
          const formattedDate = postedAt ? moment(postedAt).format("MMM D, YYYY") : "";
          return (
            <Card
              onClick={() => handleJobClick(job)}
              key={job?.id || job?.jobPostId || job?.jobId || `${jobTitle}-${index}`}
              sx={{ p: 2, cursor: "pointer" }}>
              <Stack spacing={0.75}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                  {jobTitle}
                </Typography>
                {jobLocation && (
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {jobLocation}
                  </Typography>
                )}
                {jobTypeLabel && (
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    Job type: {jobTypeLabel}
                  </Typography>
                )}
                {tradeLabels.length > 0 && (
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    Trades: {tradeLabels.slice(0, 3).join(", ")}
                    {tradeLabels.length > 3 ? ` (+${tradeLabels.length - 3} more)` : ""}
                  </Typography>
                )}
                {formattedDate && (
                  <Typography variant="caption" sx={{ color: "text.secondary" }}>
                    {formattedDate}
                  </Typography>
                )}
              </Stack>
            </Card>
          );
        })}
        {companyJobPostingsLoading && jobPostingsPage > 1 && (
          <Stack sx={{ alignItems: "center" }}>
            <Loader />
          </Stack>
        )}
        <Box ref={jobPostingsLoadMoreRef} sx={{ height: 2 }} />
      </Stack>
    );
  };

  const isProxyRestrictedTab = pathname.includes("proxySite") && restrictedTabs.includes(activeTab);

  if (noSuchData) {
    return (
      <Stack style={{ width: "100%", minHeight: "200px", marginTop: "20px" }}>
        <NoSuchPage />
      </Stack>
    );
  }



  const isVerified = companyData?.companyDetails?.verified;

  return (
    <>
      <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3, pt: 2 }}>
        {showLoader ? (
          <Pageheader headerName={`${TEXT_COMPANY}`} />
        ) : (
          <Pageheader headerName={`${TEXT_COMPANY} | ${companyData?.companyDetails?.name}`} />
        )}
        <Card className="main-content-card">
          {showLoader ? (
            <Loader />
          ) : (
            <Box className="main-content-card-list" id={scrollTargetId}>
              <Grid container spacing={1.5}>
                <Grid size={{ xs: 12, md: 12 }}>
                  <Card className="pagelist-content">
                    <CardMedia
                      component="img"
                      height="300"
                      image={companyData?.companyDetails?.imageUrl ?? PlaceholderImg}
                      alt="Company Profile"
                      onClick={() => {
                        setShowImagePreview(true);
                      }}
                    />
                    <CardHeader sx={{ pb: 0, alignItems: "center" }} action={ !pathname?.includes("proxySite") && ( <Stack direction="row" spacing={1}>
                            <Button
                              variant="outlined"
                              size="small"
                              disabled={followLoading || !currentUserId}
                              onClick={onFollowCompany}
                              sx={{ minWidth: 96 }}>
                              {companyData?.followDetails?.isFollowing ? "Unfollow" : "Follow"}
                            </Button>
                            <IconButton
                              aria-label="settings"
                              onClick={(event) => setMoreMenuAnchorEl(event.currentTarget)}>
                              <MoreVertIcon />
                            </IconButton>
                          </Stack>
                        )
                      }
                      title={
                        <Stack direction="row" sx={{ alignItems: "center" }} spacing={0.6}>
                          <Typography variant="body1">
                            {companyData?.companyDetails?.name}
                          </Typography>
                          {isVerified && (
                            <VerifiedIcon
                              sx={{
                                color: BIBlue,
                                fontSize: "1.2rem"
                              }}
                            />
                          )}
                        </Stack>
                      }
                      subheader={
                        <Typography variant="body2" sx={{ color: "text.secondary" }}>
                          {TEXT_COMPANY}
                        </Typography>
                      }
                    />

                    <Box
                      sx={{
                        position: "sticky",
                        top: 0,
                        backgroundColor: "white",
                        zIndex: 1200,
                        borderBottom: 1,
                        marginBottom: "10px",
                        borderColor: "divider"
                      }}>
                      <Tabs
                        variant="scrollable"
                        scrollButtons={false}
                        allowScrollButtonsMobile
                        textColor="primary"
                        indicatorColor="primary"
                        value={activeTab || companyTabs[0]}
                        onChange={(event, newTab) => setActiveTab(newTab)}>
                        {companyTabs.map((tab) => (
                          <Tab
                            key={tab}
                            value={tab}
                            label={tab === TEXT_PRODUCTS ? "Product used" : tab}
                          />
                        ))}
                      </Tabs>
                    </Box>
                  </Card>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                  <CompanyAboutSection
                    companyDetails={companyData?.companyDetails}
                    tradeList={companyData?.tradeList}
                    companyAddress={companyData?.companyAddress}
                    onTradesSaveSuccessfully={onTradesSaveSuccessfully}
                    onCompanyDetailsSaveSuccessfully={onCompanyDetailsSaveSuccessfully}
                    onCompanyAddressSaveSuccessfully={onCompanyAddressSaveSuccessfully}
                  />
                </Grid>
                <Grid size={{ xs: 12, md: 8 }}>
                  {isProxyRestrictedTab ? (
                    <SignInCard />
                  ) : (
                    <>
                      {activeTab === TEXT_PROJECTS && (
                        <CompanyProjectSection id={id} scrollId={scrollTargetId} />
                      )}
                      {activeTab === TEXT_PRODUCTS && (
                        <CompanyProductSection
                          id={id}
                          scrollId={scrollTargetId}
                          currentCompanyName={companyData?.companyDetails?.name || ""}
                          currentCompanyAllowPublicProductSubmission={
                            companyData?.companyDetails?.allowPublicProductSubmission
                          }
                        />
                      )}
                      {activeTab === TEXT_SITES && (
                        <CompanySiteSection id={id} scrollId={scrollTargetId} />
                      )}
                      {activeTab === TEXT_JOB_POSTINGS && (
                        <Box sx={{ pt: 1 }}>{renderCompanyJobPostings()}</Box>
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
            </Box>
          )}
        </Card>
      </Box>

      {moreMenuAnchorEl && (
        <Menu
          anchorEl={moreMenuAnchorEl}
          open={Boolean(moreMenuAnchorEl)}
          onClose={() => setMoreMenuAnchorEl(null)}
          transformOrigin={{
            horizontal: "right",
            vertical: "top"
          }}
          anchorOrigin={{
            horizontal: "right",
            vertical: "bottom"
          }}>
          {[BUTTON_SEND_IN_CHAT, BUTTON_SHARE, BUTTON_REPORT].map((item, index) => (
            <MenuItem
              onClick={() => {
                if (item === BUTTON_SHARE) {
                  onShareClick();
                } else if (item === BUTTON_SEND_IN_CHAT) {
                  onSendChatClick();
                } else if (item === BUTTON_REPORT) {
                  onReportClick();
                } else {
                  setMoreMenuAnchorEl(null);
                }
                setMoreMenuAnchorEl(null);
              }}
              style={{
                color: item === BUTTON_REPORT ? BIRed : "#083DB8"
              }}
              key={index}
              dense>
              {item}
            </MenuItem>
          ))}
        </Menu>
      )}

      {showImagePreview && (
        <PictureViewer
          isOpen={showImagePreview}
          onClose={() => {
            setShowImagePreview(false);
          }}
          src={companyData?.companyDetails?.imageUrl ?? PlaceholderImg}
        />
      )}
      {showSendInChatModal && (
        <SendInChatModal
          isOpen={showSendInChatModal}
          onClose={() => {
            setShowSendInChatModal(false);
          }}
          fromTo="Company"
          title={companyData?.companyDetails?.name}
          imageUrl={companyData?.companyDetails?.imageUrl ?? PlaceholderImg}
        />
      )}
    </>
  );
};

export default CompanyProfile;
